module.exports = __webpack_public_path__ + "static/media/Photo4.fec47d26.jpg";